/**
 * WordPress Dependencies
 */
import { __ } from "@wordpress/i18n";
import { addFilter } from "@wordpress/hooks";
import { assign, isEmpty } from "lodash";
import { createHigherOrderComponent } from "@wordpress/compose";
/**
 * Custom Imports
 */
import "./editor.scss";
import "./style.scss";
import Inspector from "./inspector";
import { customVariables } from "./variables";

/**
 * Add new attributes to the block
 */
const addAttributes = (props) => {
	const { attributes } = props;
	if (isEmpty(attributes) || props.name !== "core/video") {
		return props;
	}
	props.attributes = assign(
		props.attributes,
		{
			...attributes,
			buttonShape: {
				type: "string",
				default: "rectangle",
			},

			aspectRatio: {
				type: "string",
				default: "16-9",
			},
			playerSize: {
				type: "number",
				default: 70,
			},
			ghubPlayIconColor: {
				type: "string",
				default: "#ffffff",
			},

			ghubPlayIconBgColor: {
				type: "string",
				default: "#ff0000",
			},

			ghubPlayButtonHorizontalPosition: {
				type: "string",
				default: "center",
			},

			ghubPlayButtonVerticalPosition: {
				type: "string",
				default: "center",
			},
			ghubVideoLightbox: {
				type: "boolean",
				default: false,
			},
			ghubPlayButtonSize: {
				type: "string",
				default: "38px",
			},

			closeOnOutsideClick: {
				type: "boolean",
				default: false,
			},

			lightboxOpenEffect: {
				type: "string",
				default: "zoom",
			},

			overlayColor: {
				type: "string",
				default: "#000000",
			},
		},
		{}
	);

	return props;
};

const withAdvanceControls = createHigherOrderComponent((BlockEdit) => {
	return (props) => {
		const { name, attributes } = props;

		if (
			name !== "core/video" ||
			(name === "core/video" && isEmpty(attributes.src))
		) {
			return <BlockEdit {...props} />;
		}

		return (
			<>
				<BlockEdit {...props} />
				<Inspector {...props} />
			</>
		);
	};
}, "withAdvanceControls");

const withBlockWrapper = createHigherOrderComponent((BlockListBlock) => {
	return (props) => {
		const { attributes } = props;
		if (
			props.name !== "core/video" ||
			(props.name === "core/video" && attributes.ghubVideoLightbox !== true)
		) {
			return <BlockListBlock {...props} />;
		}
		const ghubVariables = customVariables(attributes);

		const playButtonHorizontalPosition =
			attributes?.ghubPlayButtonHorizontalPosition;
		const playButtonVerticalPosition =
			attributes?.ghubPlayButtonVerticalPosition;

		return (
			<div
				className={`ghub-video-wrapper ghub-video-horizontal-${playButtonHorizontalPosition} ghub-video-vertical-${playButtonVerticalPosition} ghub-aspect-ratio-${attributes?.aspectRatio}`}
				style={ghubVariables}
			>
				<BlockListBlock {...props} />
				<div
					className={`ghub-video-lightbox-play-button ghub-play-icon-wrapper ghub-${attributes.buttonShape}`}
				>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
						<path
							fill="currentColor"
							d="M9.525 18.025q-.5.325-1.012.038T8 17.175V6.825q0-.6.513-.888t1.012.038l8.15 5.175q.45.3.45.85t-.45.85l-8.15 5.175Z"
						/>
					</svg>
				</div>
			</div>
		);
	};
}, "withBlockWrapper");

addFilter(
	"editor.BlockListBlock",
	"ghub-video-lightbox/with-block-wrapper",
	withBlockWrapper
);
addFilter(
	"editor.BlockEdit",
	"ghub-video-lightbox/with-advance-controls",
	withAdvanceControls
);
addFilter(
	"blocks.registerBlockType",
	"ghub-video-lightbox/add-attributes",
	addAttributes
);
